module.exports = __webpack_public_path__ + "img/lee-jacobsz-profile-trans.83c688ce.png";